<template>
    <!-- <div class="login"> -->
        <b-row class="justify-content-center" align-v="center" >
            <b-col lg="4" md="6" sm="8">
                <b-form>
                    <b-form-group>
                        <b-form-input
                        v-model="email"
                        type="email"
                        required
                        placeholder="Enter email"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <b-form-input
                        type="password"
                        v-model="password"
                        required
                        placeholder="Enter password"
                        ></b-form-input>
                    </b-form-group>
                </b-form>
                
                <div style="display: flex; flex-direction: column">
                    <b-button type="submit"  class="mb-2 btn-login" @click="login">Login</b-button>
                    <b-button type="submit"  class="btn-register" @click="register">Register</b-button>
                    <hr>
                    <b-button class="mb-2 btn-google" @click="googleLogin">Login with google</b-button>
                    <b-button class="btn-facebook" @click="facebookLogin">Login with facebook</b-button>
                </div>
                
            </b-col>
        </b-row>
    <!-- </div> -->
</template>

<script>
import { firebase } from '../../firebase/firebaseConfig'

export default {
    name: 'login',
     data() {
      return {
        email: '',
        password:''
      }
    },
    methods: {
        login(e) {
            firebase
                .auth()
                .signInWithEmailAndPassword(this.email, this.password)
                .then(user => {
                    alert(`You're login as ${user.user.email}`)
                    this.$router.push('/')
                },
                error => {
                    alert(error.message)
                })
            e.preventDefault()
        },
        register(e) {
            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                .then(user => {
                    console.log('user', user.user)
                    alert(`acount created for ${user.user.email}`)
                    this.$router.push('/')
                }, 
                error => {
                    alert(error.message)
                })
            e.preventDefault()
        },
        googleLogin() {
            const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(googleAuthProvider).then(user => {
                console.log('logged in successfully', user)
                this.$router.push('/')
            })
            
        },
        facebookLogin() {
            const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
            firebase.auth().signInWithPopup(facebookAuthProvider)
            this.$router.push('/')
        }
    },
    components: {
        
    }
}
</script>

<style scoped>
    .login {
        margin: auto;
    }
    button {
        border: none;
    }
    .btn-login {
        background: #fe6ab4;
    }
    .btn-register {
        background: #732982;
    }
    .btn-google {
        background: #d63b30;
    }
    .btn-facebook {
        background: #334f8d;
    }
</style>